var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthBkgIconLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 181,
    viewBox: "0 0 252 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2214 250.143C-27.8504 242.582 -52.4102 207.426 -44.3561 172.019L-19.8697 64.3753C-11.8156 28.9689 25.9238 6.18679 63.9955 13.7484C102.067 21.3101 126.627 56.4658 118.573 91.8722L94.0865 199.516C86.0324 234.923 48.2931 257.705 10.2214 250.143Z",
    fill: "#7869B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2214 250.143V250.143C-27.8504 242.582 -52.4102 207.426 -44.3561 172.019L-19.8697 64.3753C-11.8156 28.9689 25.9238 6.18679 63.9955 13.7484C102.067 21.3101 126.627 56.4658 118.573 91.8722L94.0865 199.516C86.0324 234.923 48.2931 257.705 10.2214 250.143",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1716 13.5849L64.8198 13.9122L11.0456 250.307L9.39748 249.98L63.1716 13.5849Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.476 255.335C160.181 261.201 128.617 241.284 122.333 211.076L103.228 119.235C96.9442 89.0269 118.225 59.5119 150.519 53.6462C182.814 47.7806 214.378 67.6974 220.662 97.9057L239.767 189.746C246.051 219.954 224.77 249.47 192.476 255.335Z",
    fill: "#BDB4E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192.476 255.335V255.335C160.181 261.201 128.617 241.284 122.333 211.076L103.228 119.235C96.9442 89.0269 118.225 59.5119 150.519 53.6462C182.814 47.7806 214.378 67.6974 220.662 97.9057L239.767 189.746C246.051 219.954 224.77 249.47 192.476 255.335",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.644 255.463C191.921 255.417 192.198 255.385 192.476 255.335C192.753 255.285 193.023 255.217 193.298 255.162L151.351 53.5191C151.074 53.5648 150.796 53.5956 150.519 53.6459C150.242 53.6963 149.973 53.7649 149.697 53.8196L191.644 255.463Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.861 235.132C81.8066 236.163 63.6836 221.014 62.5874 201.469L59.2545 142.045C58.1583 122.499 74.4874 105.664 95.5414 104.633C116.595 103.602 134.718 118.75 135.815 138.296L139.147 197.72C140.244 217.265 123.915 234.101 102.861 235.132Z",
    fill: "#4C3A97"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.861 235.132V235.132C81.8066 236.163 63.6836 221.014 62.5874 201.469L59.2545 142.045C58.1583 122.499 74.4874 105.664 95.5414 104.633C116.595 103.602 134.718 118.75 135.815 138.296L139.147 197.72C140.244 217.265 123.915 234.101 102.861 235.132",
    stroke: "white",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.1207 104.653L95.962 104.612L103.281 235.111L102.44 235.152L95.1207 104.653Z",
    stroke: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 104,
    width: 10,
    height: 132
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.1207 104.653L95.962 104.612L103.281 235.111L102.44 235.152L95.1207 104.653Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBkgIconLeft);
export default __webpack_public_path__ + "static/media/auth-bkg-icon-left.b7443de5cb6bb956ff6ad55fdb40823a.svg";
export { ForwardRef as ReactComponent };